/**
 * Created by laptop on 2016-11-19.
 */
app.controller("AddContainer", ["$scope", "StaticData", "ProgramService", "$uibModalInstance", "params",
    function ($scope, StaticData, ProgramService, $uibModalInstance, params) {
        $scope.container = {
            name: "",
            type: params.type,
            parent: null,
            program: params.programId,
            required: null
        };

        $scope.requiredList = _.range(1, 11);

        console.log(params);

        StaticData.getItemsByKey("container_types").then(function (types) {
            $scope.types = types;
        });

        $scope.create = function () {
            ProgramService.createContainer($scope.container).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);